import React from 'react';
import styled from 'styled-components';
import { FilterLabel } from '@lt/components';
import { useTranslation, i18n } from '@lt/localization';
import MultichoiceFilterGroup from './components/MultichoiceFilterGroup';

import { FilterPropTypes, FilterDefaultProps } from './proptypes';

const LABEL_TEXT = i18n.t('filters.payment.title');

const FilterPaymentBenefits = (props) => {
  const { t } = useTranslation();
  return (
    <MultichoiceFilterGroup
      {...props}
      Filter={{
        ...FilterPaymentBenefits,
        filterLabel: getFilterLabel(),
      }}
      expandLabel={t('filters.show_offers')}
      visibleItems={5}
      LabelComponent={FilterLabel}
    />
  );
};

const getFilterLabel = () => <Label>{LABEL_TEXT}</Label>;

FilterPaymentBenefits.filterName = 'payment_benefits';
FilterPaymentBenefits.filterLabel = LABEL_TEXT;

FilterPaymentBenefits.propTypes = FilterPropTypes;
FilterPaymentBenefits.defaultProps = FilterDefaultProps;

const Label = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

export default FilterPaymentBenefits;
